import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColumnFilterComponent } from '../column-filter/column-filter.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-filter-sort-column-header',
  imports: [ColumnFilterComponent, NgClass],
  templateUrl: './sortable-column-header.component.html',
  styleUrl: './sortable-column-header.component.scss',
})
export class SortableColumnHeaderComponent {
  @Input() columnName!: string;
  @Input() columnKey!: string;
  @Input() options: string[] = [];
  @Input() selectedValues: string[] = [];
  @Input() sortColumn?: string;
  @Input() sortDirection?: 'asc' | 'desc';

  @Output() filterChanged = new EventEmitter<string[]>();
  @Output() sortChanged = new EventEmitter<{
    column?: string;
    direction?: 'asc' | 'desc';
  }>();

  get isActiveSort(): boolean {
    return this.sortColumn === this.columnKey;
  }

  onFilterChanged(selected: string[]) {
    this.filterChanged.emit(selected);
  }

  toggleSort() {
    let newDirection: 'asc' | 'desc' | undefined;
    let newColumn: string | undefined;

    if (!this.isActiveSort) {
      newColumn = this.columnKey;
      newDirection = 'asc';
    } else if (this.sortDirection === 'asc') {
      newColumn = this.columnKey;
      newDirection = 'desc';
    } else {
      newColumn = undefined;
      newDirection = undefined;
    }

    this.sortChanged.emit({ column: newColumn, direction: newDirection });
  }

  get hasFilters(): boolean {
    return this.options && this.options.length > 0;
  }
}
